import * as actions from '../../redux/actions';

import { AndimarTitle } from '../../common/Title/AndimarTitle';
import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import getSlides from '../../functions/getSlides/getSlides';
import termsBanner from '../../assets/andimar/terms-and-conditions-banner.jpg';

const AndimarTermsAndConditions = props => {
  const operator = CommonService.getLocal('op') || props.home.operator;

  const createMarkup = data => {
    return { __html: data };
  };
  return (
    <div>
      <KuposHelmet />
      <HeroSection
        heroImage={termsBanner}
        height={'41vh'}
        title={'Términos y condiciones'}
        description={'Home / Términos y condiciones'}
        marginTop="-70px"
      />

      <div className="new-container ">
        <AndimarTitle title={'TÉRMINOS Y CONDICIONES'} />

        <div
          dangerouslySetInnerHTML={createMarkup(operator && operator.terms ? operator.terms : '')}
          className="lh-1-3 terms-and-conditions newtnc"
          style={{ fontSize: '13px' }}
        />
      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AndimarTermsAndConditions);



// WEBPACK FOOTER //
// ./src/features/themes/themes1/AndimarPages/AndimarTermsAndConditions.js